import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import { PRINCIPLES, PRINCIPLES_INTRO } from "../data/principles";
import { SITE } from "../data/site";
import "../styles/principles.css";

const num = (i: number) => String(i + 1).padStart(2, "0");

export default function PrinciplesPage() {
  useEffect(() => {
    document.title = "AI 네이티브 개발 원칙 | kwangbok.me";
  }, []);

  return (
    <SiteLayout crumb="principles">
      <div className="pr">
        <header className="pr-head">
          <span className="eyebrow">$ cat PRINCIPLES.md</span>
          <h1>AI 네이티브 개발 원칙</h1>
          <div className="pr-intro">
            {PRINCIPLES_INTRO.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        </header>

        <nav className="pr-toc card" aria-label="원칙 목차">
          <ol>
            {PRINCIPLES.map((p, i) => (
              <li key={p.id}>
                <Link to={`/principles#${p.id}`}>
                  <span className="mono">{num(i)}</span>
                  {p.title}
                </Link>
              </li>
            ))}
          </ol>
        </nav>

        <ol className="pr-list">
          {PRINCIPLES.map((p, i) => (
            <li key={p.id} id={p.id} className="card pr-item">
              <div className="pr-item-head">
                <span className="mono pr-num">{num(i)}</span>
                <h2>{p.title}</h2>
              </div>
              <div className="pr-item-body">
                <div className="pr-text">
                  {p.body.map((b) => (
                    <p key={b}>{b}</p>
                  ))}
                </div>
                <div className="pr-side">
                  <h3 className="mono">이렇게 합니다</h3>
                  <ul className="pr-practice">
                    {p.practice.map((t) => (
                      <li key={t}>{t}</li>
                    ))}
                  </ul>
                  <h3 className="mono">적용한 곳</h3>
                  <ul className="pr-cases">
                    {p.cases.map((c) => (
                      <li key={c.label + c.text}>
                        {c.to ? (
                          <Link to={c.to} className="pr-case-label">{c.label}</Link>
                        ) : (
                          <strong className="pr-case-label">{c.label}</strong>
                        )}
                        <span>{c.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="pr-next">
          <a href={SITE.portfolio_pdf} target="_blank" rel="noopener noreferrer" className="chip">
            서비스 설계 노트 PDF
          </a>
          <Link to="/apps" className="chip">만든 앱 보기</Link>
          <Link to="/#career" className="chip">경력 보기</Link>
        </div>
      </div>
    </SiteLayout>
  );
}
